<template>
  <div class="tabs">
    <!-- Conditionally render the tab header if there's at least one visible tab -->
    <ul v-if="filteredTabs.length > 0" class="tab-header d-flex flex-wrap list-unstyled p-0 m-0">
      <li v-for="tab in filteredTabs" :key="tab.title" @click="handleTabHeaderClick(tab.title)"
        :class="['tab-item', { active: selectedTitle === tab.title }]">
        <span v-if="tab.icon" :class="tab.icon" class="tab-icon"></span>
        {{ tab.title }}
      </li>
    </ul>

    <!-- Slot for tab content -->
    <slot />
  </div>
</template>

<script>
import { ref, watch, toRefs, provide, computed } from "vue";

export default {
  props: {
    selectedTab: { type: String, default: "" }, // Prop for selected tab
  },

  setup(props, { emit, slots }) {
    const { selectedTab } = toRefs(props);

    // Extract tab info including title, icon, and visibility
    const tabs = ref(slots.default().map(tab => ({
      title: tab.props.title,
      icon: tab.props.icon || null,
      visible: tab.props.visible !== false
    })));

    const selectedTitle = ref(selectedTab.value || tabs.value[0]?.title);

    // Filter visible tabs
    const filteredTabs = computed(() => {
      return tabs.value.filter(tab => tab.visible);
    });

    // Watch for selectedTab prop changes
    watch(selectedTab, (newTab) => {
      selectedTitle.value = newTab;
    });

    provide("selectedTitle", selectedTitle);

    const handleTabHeaderClick = (title) => {
      selectedTitle.value = title;
      emit("update:selectedTab", title);
      emit("headerClicked", title);
    };

    return {
      filteredTabs,
      selectedTitle,
      handleTabHeaderClick,
    };
  },
};
</script>

<style scoped>
/* Styles for the TabsWrapper */
.tabs {
  display: flex;
  flex-direction: column;
  position: relative;
}

.tab-header {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  font-weight: 500;
}

.tab-header li {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  color: #606060;
  font-size: 14px;
  transition: color 0.2s ease-in-out;
  border-bottom: 2px solid transparent;
}

.tab-header li:hover {
  color: #111;
}

.tab-header li.active {
  color: #000;
  border-bottom: 3px solid #863232;
  font-weight: bold;
}

.tab-icon {
  margin-right: 8px;
  font-size: 0.9em;
}

.tabs .tab-content {
  width: 100%;
}
</style>